<template>
  <div id="app">
    <RiveGame src="/animations/vacaciones.riv" fit="contain" alignment="center" />
  </div>
</template>

<script>
import RiveGame from './components/RiveGame.vue'

export default {
  name: 'App',
  components: {
    RiveGame
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  
}

</style>
